import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import { LOGINAPI, USERAPI } from '@/api/users'
import { PermissionModule } from '@/store/modules/permission'
import {
  getToken,
  setToken,
  removeToken,
  setUsername,
  getUsername,
  removeUsername,
  setDisplayName,
  getDisplayName,
  removeDisplayName,
  getLoginTimes,
  setLoginTimes,
  setRole,
  removeRole,
  setAvatar,
  removeAvatar,
  removeuserCurrentApp,
  getAvatar,
  getRole,
  removeuserCurrentAppName,
  getuserWorkCode,
  setuserWorkCode,
  removeuserWorkCode,
  getuserCurrentApp
} from '@/utils/cookies'
import { resetRouter } from '@/router'
import store from '@/store'
import { RouteConfig } from 'vue-router'
import { Message } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { ConfigModule } from '@/store/modules/config'
import { getAppid } from '@/utils/utils'

export interface IUserState {
  token: string;
  username: string;
  displayName: string;
  avatar: string;
  workcode: string;
  roles: string;
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || '';
  public username = getUsername() || '';
  public displayName = getDisplayName() || '';
  public avatar = getAvatar() || '';
  public workcode = getuserWorkCode() || '';
  public roles: string = getRole() || '';
  public userPermission: RouteConfig[] = [];
  public userPermissionTimes = 0; // 获取用户菜单权限请求次数
  public userinfoTimes = 0; // 请求GetYachUserInfo接口次数

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_NAME(name: string) {
    this.username = name
  }

  @Mutation
  private SET_DISPLAYNAME(name: string) {
    this.displayName = name
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_WORKCODE(workcode: string) {
    this.workcode = workcode
  }

  @Mutation
  private SET_ROLES(roles: string) {
    this.roles = roles
  }

  @Mutation
  private SET_PERMISSION(data: RouteConfig[]) {
    this.userPermission = data
    this.userPermissionTimes++
  }

  @Mutation
  private SET_USERINfO_TIMES() {
    this.userinfoTimes++
  }

  @Action
  public ResetToken() {
    removeToken()
    removeUsername()
    removeDisplayName()
    removeRole()
    removeAvatar()
    removeuserCurrentApp()
    removeuserCurrentAppName()
    this.SET_TOKEN('')
    this.SET_ROLES('')
    this.SET_NAME('')
    this.SET_DISPLAYNAME('')
    this.SET_AVATAR('')
    this.SET_WORKCODE('')
  }

  @Action
  public async LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    removeToken()
    removeUsername()
    removeDisplayName()
    removeRole()
    removeAvatar()
    resetRouter()
    removeuserCurrentApp()
    removeuserCurrentAppName()
    removeuserWorkCode()

    this.SET_TOKEN('')
    this.SET_ROLES('')
    this.SET_NAME('')
    this.SET_DISPLAYNAME('')
    this.SET_AVATAR('')
    this.SET_WORKCODE('')
  }

  @Action
  public async GetUserPermission() {
    const { data } = await LOGINAPI.getPermissionList()
    this.SET_PERMISSION(data)
  }

  // 设置Token&用户名
  @Action
  public SetNameNToken(authParams: any) {
    setToken(authParams.Token)
    setUsername(authParams.username)
    setDisplayName(authParams.display_name)
    this.SET_TOKEN(authParams.Token)
    this.SET_NAME(authParams.username)
    this.SET_DISPLAYNAME(authParams.display_name)

    if (authParams.zhiyinlou) {
      this.SET_AVATAR(authParams.zhiyinlou.avatar)
      this.SET_WORKCODE(authParams.zhiyinlou.workcode)
    }
    setLoginTimes('0')
  }

  // 获取当前登录的用户信息
  @Action
  public async GetYachUserInfo() {
    this.SET_USERINfO_TIMES()
    const { data } = await LOGINAPI.getYachUserInfo()
    this.SET_AVATAR(data.avatar)
    this.SET_WORKCODE(data.workcode)
  }

  // 知音楼query-token登录
  @Action
  public ssoLogin(authParams: any) {
    return new Promise((resolve, reject) => {
      LOGINAPI.ssoLogin({
        token: authParams.token,
        yach_id:
          getuserCurrentApp() === '5'
            ? process.env.VUE_APP_ADMINI_LOGIN_APPID
            : process.env.VUE_APP_LOGIN_APPID || ''
      })
        .then((response) => {
          setToken(response.Token)
          setUsername(response.username)
          setDisplayName(response.display_name || '')
          this.SET_TOKEN(response.Token)
          this.SET_NAME(response.username)
          this.SET_DISPLAYNAME(response.display_name || '')
          if (response.zhiyinlou) {
            this.SET_AVATAR(response.zhiyinlou.avatar)
            this.SET_WORKCODE(response.zhiyinlou.workcode)
          }
          setLoginTimes('0')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  // token登录认证-获取用户信息
  @Action
  public verifyToken(authParams: any) {
    const appid = getAppid()
    return new Promise((resolve, reject) => {
      USERAPI.verifyToken({
        token: authParams.token,
        appid: authParams.appid
      })
        .then((response) => {
          if (response.stat === 1) {
            setToken(authParams.token)
            setUsername(response.data.account)
            setDisplayName(response.data.name || '')
            setuserWorkCode(response.data.workcode || '')
            // setRole(response.data.role)
            const avatar = response.data.avatar.startsWith('https:')
              ? response.data.avatar
              : null
            setAvatar(avatar)
            this.SET_TOKEN(authParams.token)
            this.SET_NAME(response.data.account)
            this.SET_DISPLAYNAME(response.data.name || '')
            this.SET_WORKCODE(response.data.workcode)
            // this.SET_ROLES(response.data.role)
            this.SET_AVATAR(avatar)
            setLoginTimes('0')
          }
          resolve(response)
        })
        .catch((error) => {
          if (error.stat === 0) {
            // token失效的校验失败，重新登陆
            const loginTimes = Number(getLoginTimes())
            if (loginTimes <= 1) {
              // 尝试登录2次，第3次不跳转
              setLoginTimes((Number(getLoginTimes()) + 1).toString())
              const hashPath = (window as any).location.hash.substring(1) as any
              if (appid) {
                if (appid === '5') {
                  (window as any).location =
                    process.env.VUE_APP_ADMINI_LOGIN_API +
                    (hashPath
                      ? `?redirect=${encodeURIComponent(hashPath)}`
                      : '')
                }
              } else {
                (window as any).location =
                  process.env.VUE_APP_LOGIN_API +
                  (hashPath ? `?redirect=${encodeURIComponent(hashPath)}` : '')
              }
            }
          } else {
            // 500等错误;
            Message.error('知音楼用户验证失败，请稍候重试！')
          }
        })
    })
  }

  // 设置用户角色
  @Action
  public setUserRole(userRole: string) {
    this.SET_ROLES(userRole)
  }

  // 用户切换工单类型
  @Action
  public async UserChangeTicket() {
    removeRole()
    resetRouter()
    removeuserCurrentApp()
    removeuserCurrentAppName()

    this.SET_ROLES('')
    PermissionModule.setFirstFlag(true)
    PermissionModule.setHasConstantFlag(true)
    AppModule.SetShowNavbarPlace('')
    ConfigModule.setIssueTypeOptions([])
  }
}

export const UserModule = getModule(User)
